import React from 'react';
import CandyLogo from './CandyLogo';

/**
 * Shared frame for the sign-in screens: candy backdrop, frosted card, brand header.
 */
export default class LoginCard extends React.Component {
    render() {
        return (
            <div className="login-bg">
                <div className="login-bg__blob login-bg__blob--1" />
                <div className="login-bg__blob login-bg__blob--2" />
                <div className="login-bg__blob login-bg__blob--3" />

                <div className="login-card">
                    <div className="login-brand">
                        <CandyLogo size={88} />
                        <h1>Candy</h1>
                    </div>

                    {this.props.children}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/components/LoginCard.js